module.exports = __webpack_public_path__ + "static/img/day3.91c961f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day3.jpg
// module id = s07S
// module chunks = 0